import { STAGE_LABELS } from "@lib/types";

const STAGE_COLORS: Record<string, string> = {
  rejected: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400",
  withdrawn: "bg-gray-200 text-gray-500 dark:bg-gray-700 dark:text-gray-400",
  placed: "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400",
};

const DEFAULT_COLOR = "bg-accent/10 text-accent";

interface StageBadgeProps {
  stage: string;
  /** Hover text, e.g. the recorded rejection / withdrawal reason. */
  title?: string;
}

export function StageBadge({ stage, title }: StageBadgeProps) {
  return (
    <span
      title={title}
      className={`rounded-full px-2 py-0.5 text-[10px] font-medium ${STAGE_COLORS[stage] ?? DEFAULT_COLOR}`}
    >
      {STAGE_LABELS[stage] ?? stage}
    </span>
  );
}
